<template>
  <v-layout align-center column>
    <img
      src="../../assets/HubungiKami/Hero.png"
      srcset="
        ../../assets/HubungiKami/Hero@2x.png 2x,
        ../../assets/HubungiKami/Hero@3x.png 3x
      "
      class="Hero"
    />
    <p
      class="Text-Hero"
      v-bind:style="{ marginTop: marginTopText, width: textWidth, fontSize }"
    >
      Get In Touch
    </p>
    <p
      class="Desc-Hero"
      v-bind:style="{
        marginTop: marginTopDesc,
        width: descWidth,
        fontSize: fontSizeDesc,
      }"
    >
      Tambah Penghasilanmu dengan Cepat, Lakukan Pendanaan di Dompet Kilat
    </p>
  </v-layout>
</template>
<script>
export default {
  data() {
    return {
      heroTextSize: `48px`,
      marginLeft: `${window.innerWidth / 8}px`,
      marginTopText: `${window.innerWidth / 12}px`,
      marginTopDesc: `${window.innerWidth / 8}px`,

      width: `${window.innerWidth / 4}px`,
      fontSize: `48px`,
      fontSizeDesc: `16px`,
    };
  },
  mounted() {
    this.onResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeEventHandler);
  },
  created() {
    this.resizeEventHandler();
    window.addEventListener("resize", this.resizeEventHandler);
  },
  methods: {
    resizeEventHandler() {
      this.marginLeft = `${window.innerWidth / 8}px`;
      this.marginTopText = `${window.innerWidth / 12}px`;
      this.marginTopDesc = `${window.innerWidth / 8}px`;
      this.descWidth = `${window.innerWidth / 2}px`;
      this.textWidth = `${window.innerWidth / 4}px`;
      this.width = `${window.innerWidth / 3}px`;
      this.fontSize = `${window.innerWidth / 35}px`;
      this.fontSizeDesc = `${window.innerWidth / 100}px`;
    },
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },
  },
};
</script>
<style scoped>
.Text-Hero {
  width: 763px;
  height: 56px;
  margin: 69px auto 0 auto;
  font-family: Sora;
  font-size: 48px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
  /* position: absolute; */
}
.Desc-Hero {
  width: 742px;
  height: 48px;
  margin: -40px auto auto;
  font-family: Sora;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
  position: absolute;
}
.Hero {
  /* width: 1600px; */
  /* height: 490px; */
  /* margin: -90px 0 427px; */
  padding: 0 0 0px;
  object-fit: contain;
  position: relative;
}
</style>
